import React from "react"

import "../../styles/Common/GenericComponenetHeader.less"
import Image from "./Image"
export default function GenericComponenetHeader({
  BHTTitle = "BHTTitle",
  BHTContainer = "BHTContainer",
  BHTarrowStyle = "BHTarrowStyle",
  ...props
}) {
  return (
    <div className={BHTContainer}>
      <div className={BHTTitle} onClick={props.onClick}>
        {props.content.title}
      </div>
      {props.icon ? (
        <Image
          src={`assets/${props.content.iconId}.svg`}
          className={BHTarrowStyle}
          alt={""}
          onClick={props.onClick}
        />
      ) : (
        ""
      )}
    </div>
  )
}
